// Pure rules shared by the Hono API and the React UI: keep free of runtime imports
export type ActionPlanRole = 'admin' | 'viewer' | 'new_user'

// period_end is unix seconds; null/undefined means recurring (never ended)
export function isGoalEnded(periodEnd: number | null | undefined, nowSeconds: number): boolean {
  return typeof periodEnd === 'number' && periodEnd < nowSeconds
}

function ownsGoal(userId: string | undefined, goalOwnerId: string | null | undefined): boolean {
  return !!userId && userId === goalOwnerId
}

// Creating a plan grants nothing: access follows the current goal owner only
export function canManagePlan(
  role: ActionPlanRole | undefined,
  userId: string | undefined,
  goalOwnerId: string | null | undefined,
): boolean {
  if (role === 'admin') return true
  return role === 'viewer' && ownsGoal(userId, goalOwnerId)
}

export function canCreatePlan(
  role: ActionPlanRole | undefined,
  userId: string | undefined,
  goalOwnerId: string | null | undefined,
  periodEnd: number | null | undefined,
  nowSeconds: number,
): boolean {
  if (role === 'admin') return true
  return role === 'viewer' && ownsGoal(userId, goalOwnerId) && !isGoalEnded(periodEnd, nowSeconds)
}

export function canDeleteReflection(
  role: ActionPlanRole | undefined,
  userId: string | undefined,
  reflectionAuthorId: string | null | undefined,
): boolean {
  if (role === 'admin') return true
  return role === 'viewer' && !!userId && userId === reflectionAuthorId
}
